import api from '@pray/shared/utils/api';

export async function getPayoutsSummary(artistId = '') {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/payouts/summary`;
  const response = await api.executeGetRequest(url);

  return response.data.data;
}
